import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { HeaderBar } from './HeaderBar';
import { AdPanel } from './AdPanel';
import { RightPanel } from './RightPanel';
import { USERS, VERSIONS } from './data';
import { ResolveState, RightTabId, SummaryLensId } from './types';
export function AegisRIA() {
  const [currentUser, setCurrentUser] = useState('maria');
  const [activeVersionId, setActiveVersionId] = useState('v1');
  const [rightTab, setRightTab] = useState<RightTabId>('summary');
  const [summaryLens, setSummaryLens] = useState<SummaryLensId>('marketing');
  const [resolveStates, setResolveStates] = useState<Record<string, ResolveState>>({});
  const [expandedFinding, setExpandedFinding] = useState<string | null>(null);
  const [scanning, setScanning] = useState(false);
  const [comparing, setComparing] = useState(false);
  const [compareVersionId, setCompareVersionId] = useState('v1');
  const me = USERS[currentUser];
  const isReviewer = me.role === 'reviewer';
  const isSubmitter = me.role === 'submitter';
  const v = VERSIONS.find(x => x.id === activeVersionId)!;
  const narrative = v.narrative[summaryLens] || v.narrative.marketing;
  const hasBlockers = v.blockers.length > 0;
  const allItems = [...v.blockers, ...v.suggestions];
  const allHandled = allItems.every(f => resolveStates[f.id] === 'resolved' || resolveStates[f.id] === 'na');
  const handleResolve = (id: string, s: ResolveState) => setResolveStates(p => ({
    ...p,
    [id]: s
  }));
  const simulateUpload = () => {
    setScanning(true);
    setRightTab('summary');
    setTimeout(() => {
      setScanning(false);
      const next = VERSIONS.findIndex(x => x.id === activeVersionId) + 1;
      if (next < VERSIONS.length) setActiveVersionId(VERSIONS[next].id);
    }, 2000);
  };
  const handleToggleCompare = () => {
    setComparing(!comparing);
    if (!comparing) {
      setCompareVersionId(VERSIONS.find(x => x.id !== activeVersionId)?.id || 'v1');
    }
  };
  return <div style={{
    display: 'grid',
    gridTemplateColumns: '260px 1fr',
    height: '100vh',
    fontFamily: "'DM Sans', -apple-system, sans-serif",
    background: '#FAF9F7',
    color: '#1C2530',
    overflow: 'hidden'
  }} data-id="element-133">
      <Sidebar currentUser={currentUser} activeVersionId={activeVersionId} onVersionChange={setActiveVersionId} onUserChange={setCurrentUser} onLensChange={lens => setSummaryLens(lens as SummaryLensId)} data-id="element-134" />

      <main style={{
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column'
    }} data-id="element-135">
        <HeaderBar version={v} comparing={comparing} activeVersionId={activeVersionId} onToggleCompare={handleToggleCompare} data-id="element-136" />

        <div style={{
        flex: 1,
        display: 'grid',
        gridTemplateColumns: comparing ? '1fr 1fr 420px' : '1fr 420px',
        overflow: 'hidden'
      }} data-id="element-137">
          <AdPanel version={v} scanning={scanning} comparing={comparing} compareVersionId={compareVersionId} onCompareVersionChange={setCompareVersionId} activeVersionId={activeVersionId} isSubmitter={isSubmitter} onUpload={simulateUpload} data-id="element-138" />

          <RightPanel version={v} narrative={narrative} rightTab={rightTab} onTabChange={setRightTab} summaryLens={summaryLens} onLensChange={setSummaryLens} hasBlockers={hasBlockers} isReviewer={isReviewer} isSubmitter={isSubmitter} resolveStates={resolveStates} onResolve={handleResolve} expandedFinding={expandedFinding} onExpandFinding={setExpandedFinding} currentUser={currentUser} scanning={scanning} allHandled={allHandled} data-id="element-139" />
        </div>
      </main>
    </div>;
}